var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _onCartUpdateListener, _onSectionsToUpdateListener, _CartDrawer_instances, onCartUpdate_fn, onSectionsToUpdate_fn, closeOtherDialogs_fn;
import { C as CustomDialog } from "./custom-dialog-B1OptZSU.js";
import { C as CustomEvents } from "./events-DeC3n8dp.js";
import { p as prefersReducedMotion } from "./utilities-2Suih3Nm.js";
import "./component-cLJ9vlHA.js";
import "./critical-Da0Dmhh9.js";
import "./focus-D9T8n_CN.js";
class CartDrawer extends CustomDialog {
  constructor() {
    super();
    __privateAdd(this, _CartDrawer_instances);
    __privateAdd(this, _onCartUpdateListener);
    __privateAdd(this, _onSectionsToUpdateListener);
    __privateSet(this, _onCartUpdateListener, __privateMethod(this, _CartDrawer_instances, onCartUpdate_fn).bind(this));
    __privateSet(this, _onSectionsToUpdateListener, __privateMethod(this, _CartDrawer_instances, onSectionsToUpdate_fn).bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("cart:update", __privateGet(this, _onCartUpdateListener));
    document.addEventListener(CustomEvents.cartSectionsToUpdate, __privateGet(this, _onSectionsToUpdateListener));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("cart:update", __privateGet(this, _onCartUpdateListener));
    document.removeEventListener(CustomEvents.cartSectionsToUpdate, __privateGet(this, _onSectionsToUpdateListener));
  }
  get sectionId() {
    const { sectionId } = this.dataset;
    if (!sectionId) throw new Error("Section id missing");
    return sectionId;
  }
}
_onCartUpdateListener = new WeakMap();
_onSectionsToUpdateListener = new WeakMap();
_CartDrawer_instances = new WeakSet();
onCartUpdate_fn = async function(event) {
  const { data } = event.detail || {};
  if ((data == null ? void 0 : data.source) !== "product-form") return;
  if ((data == null ? void 0 : data.openDrawer) === false) return;
  await __privateMethod(this, _CartDrawer_instances, closeOtherDialogs_fn).call(this);
  this.showDialog();
  const drawerBody = this.querySelector(".js-drawer-body");
  if (drawerBody) {
    drawerBody.scrollTo({
      top: 0,
      behavior: prefersReducedMotion() ? "auto" : "smooth"
    });
  }
};
onSectionsToUpdate_fn = function(event) {
  const { sections } = event.detail || {};
  if (!sections) return;
  sections.push(this.sectionId);
};
closeOtherDialogs_fn = async function() {
  const closePromises = Array.from(document.querySelectorAll("dialog[open]")).map((dialog) => {
    var _a;
    const customDialog = dialog.closest("custom-dialog, quick-view-dialog, cart-drawer");
    if (customDialog && customDialog !== this) {
      return (_a = customDialog.closeDialog) == null ? void 0 : _a.call(customDialog);
    }
  });
  await Promise.all(closePromises);
};
if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
